<div class="wrapper cloud-biss-dialog">
  <div *ngIf="!downloadBiss" [ngClass]="verificationMessage != null ? 'hide': 'show'">
    <div *ngIf="hasBiss">
      <p>{{verificationMessage}}</p>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <div *ngIf="!hasBiss">
      <p>{{operationMessage}}</p>
    </div>
  </div>


  <div *ngIf="downloadBiss">
    <div class="container-button">
      <button mat-button mat-dialog-close>
        <cqes-icon icon="close" class="close-icon">close</cqes-icon>
      </button>
    </div>

    <div class="content-message">
      <div>
        <p>{{'bissLogin.ifBTrustnotInstall' | translate}}</p>
        <hr>
        <p>{{'bissLogin.downloadBissTitle' | translate}}
          <a [href]='linkDownload'>
            {{'bissLogin.downloadLink' | translate}}
          </a>
        </p>
        <hr>
        <p>{{'bissLogin.detailedInformation' | translate}}</p>
        <p>
          {{'bissLogin.forItsInstallation' | translate}}
        </p>
        <p>
          {{'bissLogin.functionalityYouCanFind' | translate}}
          <a href='https://store.borica.bg/bg/b-trust/certificates/biss'>
            {{'bissLogin.here' | translate}}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>